const carList = [
  {
    "name":"奥迪A6L",
    "price":"333",
    "img": require("../img/car/car01.jpg")
  },
  {
    "name":"奥迪S8",
    "price":"933",
    "img": require("../img/car/car02.jpg")
  },
  {
    "name":"宝马740",
    "price":"720",
    "img": require("../img/car/car03.jpg")
  },
  {
    "name":"宝马M4",
    "price":"1500",
    "img": require("../img/car/car04.png")
  },
  {
    "name":"保时捷911.992",
    "price":"1333",
    "img": require("../img/car/car05.jpg")
  },
  {
    "name":"保时捷帕拉梅拉",
    "price":"1067",
    "img": require("../img/car/car06.jpg")
  },
  {
    "name":"奔驰 G65",
    "price":"1500",
    "img": require("../img/car/car07.jpg")
  },
  {
    "name":"奔驰G500",
    "price":"1100",
    "img": require("../img/car/car08.jpg")
  },
  {
    "name":"奔驰S400",
    "price":"933",
    "img": require("../img/car/car09.jpg")
  },
  {
    "name":"奔驰迈巴赫S480",
    "price":"1267",
    "img": require("../img/car/car10.jpg")
  },
  {
    "name":"奔驰斯宾特",
    "price":"1067",
    "img": require("../img/car/car11.png")
  },
  {
    "name":"奔驰威霆",
    "price":"600",
    "img": require("../img/car/car12.jpg")
  },
  {
    "name":"宾利飞驰",
    "price":"1667",
    "img": require("../img/car/car13.jpg")
  },
  {
    "name":"法拉利 296",
    "price":"4667",
    "img": require("../img/car/car14.jpg")
  },
  {
    "name":"法拉利 F8",
    "price":"4000",
    "img": require("../img/car/car15.jpg")
  },
  {
    "name":"法拉利488",
    "price":"4000",
    "img": require("../img/car/car16.jpg")
  },
  {
    "name":"法拉利488GTB",
    "price":"2500",
    "img": require("../img/car/car17.jpg")
  },
  {
    "name":"丰田埃尔法",
    "price":"1200",
    "img": require("../img/car/car18.jpg")
  },
  {
    "name":"福特野马Mustang 敞篷",
    "price":"667",
    "img": require("../img/car/car19.jpg")
  },
  {
    "name":"兰博基尼·Aventador (大牛)",
    "price":"5333",
    "img": require("../img/car/car20.jpg")
  },
  {
    "name":"兰博基尼飓风Huracan(小牛) ",
    "price":"3333",
    "img": require("../img/car/car21.jpg")
  },{
    "name":"劳斯莱斯古斯特",
    "price":"2167",
    "img": require("../img/car/car22.jpg")
  },
  {
    "name":"雷克萨斯LX570",
    "price":"667",
    "img": require("../img/car/car23.jpg")
  },
  {
    "name":"路虎揽胜",
    "price":"533",
    "img": require("../img/car/car24.jpg")
  },
  {
    "name":"路虎卫士110",
    "price":"833",
    "img": require("../img/car/car25.jpg")
  },
  {
    "name":"迈凯伦600LT ",
    "price":"1867",
    "img": require("../img/car/car26.jpg")
  },
  {
    "name":"腾势D9",
    "price":"700",
    "img": require("../img/car/car27.png")
  }
]
export default carList